import { Component, Input, OnInit } from '@angular/core';
import { BrandService } from '../../../../../../../services/brand.service';

@Component({
  selector: 'app-lender-listing',
  templateUrl: './lender-listing.component.html',
  styleUrls: ['./lender-listing.component.scss']
})
export class LenderListingComponent implements OnInit {
  @Input() listing: any;
  @Input() officeStatus: any;
  @Input() rowNumber: number;

  public wasabiLogo: string = 'https://s3.us-central-1.wasabisys.com/fru-client-logos/production/';
  public s3Logo: string = 'https://s3-us-west-2.amazonaws.com/fru-client-logos/production/';
  public isTopTenBestLenders: boolean;

  constructor(public brandService: BrandService) {
    this.isTopTenBestLenders = this.brandService.isTop10;
  }

  ngOnInit() {}

  public time () {
    var timestamp = Math.floor(new Date().getTime() / 1000);
    return timestamp;
  }

  public getWasabiLogo (event) {
    console.debug(event);
    event.target.src = this.wasabiLogo + '300x100/' + this.listing.client_id.toLowerCase() + '.png' + this.time();
  }

  public floor(value : number) {
    return Math.floor(value);
  }
}
